import React, { Component, useState, useEffect, useRef, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'underscore';

import DatabaseService from 'services/DatabaseService.js';

import {Button, Modal,Grid,Dropdown, Header, Input, Message, Search, Checkbox, Icon} from 'semantic-ui-react';

import {colors, fontSizes, spacings, shadow, buttons} from 'style';

var style = {

    loaderContainer: {
        paddingTop: '150px',
        paddingBottom: '150px',
    },
    button: {
        marginLeft: spacings.small,
        marginRight: spacings.small,
        ...buttons.short,
    },
    container : {
        marginTop : '30px',
        textAlign : 'center',
        marginRight : 'auto',
        marginLeft : 'auto'
        
    },
    profilestag : {
        display:'inline-block',
        padding:'10px',
        borderRadius: '100px',
        color: '#fff',
        backgroundColor:'#FFA500',
        marginRight:'1'
    }
};

const UploadCompetitionTemplateModel = ({t, onClose}) => {
    const [isPublic, setIsPublic] = useState(false)
    const [complete, setComplete] = useState()
    const [template, setTemplate] = useState()
    const [templateFormat, setTemplateFormat] = useState()
    const [banner, setBanner] = useState()
    const [preBanner, setPreBanner] = useState()
    const [seasonBanner, setSeasonBanner] = useState()
    const [templateFile, setTemplateFile] = useState()
    const [bannerFile, setBannerFile] = useState()
    const [preBannerFile, setPreBannerFile] = useState()
    const [seasonBannerFile, setSeasonBannerFile] = useState()
    const [error, setError] = useState()
    const [uploading, setUploading] = useState(false)
    const [activitiesAsset, setActivitiesAsset] = useState({})

    const templateSelector = useRef()
    const bannerSelector = useRef()
    const preBannerSelector = useRef()
    const seasonBannerSelector = useRef()

    const activitiesFileRefs = useRef([])

    const uploadJSON = async (type) => {
        templateSelector.current.click()
    }

    const uploadBanner = async (type) => {
        bannerSelector.current.click()
    }

    const uploadPreBanner = async (type) => {
        preBannerSelector.current.click()
    }

    const uploadSeasonBanner = async (type) => {
        seasonBannerSelector.current.click()
    }

    useEffect(() => {
        if (!template)
            return

        if(templateFormat == 'json') {
            if (template.banner?.dataURL) {
                setBanner(template.banner.dataURL)
                setComplete(true)
            }

            if (template.preBanner?.dataURL) {
                setPreBanner(template.preBanner.dataURL)
            }

            if (template.seasonBanner?.dataURL) {
                setSeasonBanner(template.seasonBanner.dataURL)
            }
        }
        else if(templateFormat == 'xlsx') {
            setComplete(true)
        }

        let totalActivities = 0
        if (_.isArray(template?.competitionCategories)) {
            for(let competitionCategory of template.competitionCategories) {
                if (_.isArray(competitionCategory?.category?.activities)) {
                    for (let activity of competitionCategory.category.activities) {
                        if (!activity.tag) {
                            
                            setError(`Missing Activity Tag for ${activity.title}`)
                        }
                        setActivitiesAsset(activitiesAsset => ({
                            ...activitiesAsset,
                            [activity.tag]:  activity.image?.dataURL || null
                        }))

                        totalActivities += 1
                    }   
                }
            }
        }

        activitiesFileRefs.current = Array(totalActivities)
            .fill()
            .map((_, i) => activitiesFileRefs.current[i] || createRef());
        
    }, [template])

    const saveTemplate = async (event) => {
        var file = event.target.files[0];
        event.target.value=null;
        setError()
        setTemplateFile(file.name)
        var reader = new FileReader();
        reader.onload = async (e) => {
            let result = e.target.result
            try {
                if(file.name?.endsWith('.json')) {
                    const text = new TextDecoder('utf-8').decode(result);
                    let parsed = JSON.parse(text)
                    setTemplate(parsed)
                    setTemplateFormat("json")
                }
                else if(file.name?.endsWith('.xlsx')) {

                    function bytesToBase64(bytes) {
						const CHUNK_SIZE = 0x8000;
						const chunks = [];
						for (let offset = 0; offset < bytes.length; offset += CHUNK_SIZE) {
							chunks.push(String.fromCharCode.apply(null, bytes.subarray(offset, offset + CHUNK_SIZE)));
						}
						return btoa(chunks.join(''));
					}

					const arrayBuffer = result; // ArrayBuffer
    				const bytes = new Uint8Array(arrayBuffer);
                    let base64 = bytesToBase64(bytes)
                    console.log(base64)
                    setTemplate(base64)
                    setTemplateFormat("xlsx")

                } else {
                    setError('Template must be in JSON or XLSX format')
                }
            } catch(e) {
                setError('Invalid JSON')
            }
            setComplete(!!result && !!banner/* && !!preBanner && !!seasonBanner*/)
        }
        //reader.readAsText(file, 'UTF-8');
        reader.readAsArrayBuffer(file);
        
    }

    const saveBanner = async (event) => {
        var file = event.target.files[0];
        event.target.value=null;
        setError()
        setBannerFile(file.name)
        var reader = new FileReader();
        reader.onload = async (e) => {
            let result = e.target.result
            setBanner(result)
            setComplete(!!template && !!result/* && !!preBanner && !!seasonBanner*/)
        }
        reader.onerror = () => {
            setError('Invalid Image')
        }
        reader.readAsDataURL(file);
    }

    const savePreBanner = async (event) => {
        var file = event.target.files[0];
        event.target.value=null;
        setError()
        setPreBannerFile(file.name)
        var reader = new FileReader();
        reader.onload = async (e) => {
            let result = e.target.result
            setPreBanner(result)
            setComplete(!!template && !!banner/* && !!result && !!seasonBanner*/)
        }
        reader.onerror = () => {
            setError('Invalid Image')
        }
        reader.readAsDataURL(file);
    }

    const saveSeasonBanner = async (event) => {
        var file = event.target.files[0];
        event.target.value=null;
        setError()
        setSeasonBannerFile(file.name)
        var reader = new FileReader();
        reader.onload = async (e) => {
            let result = e.target.result
            setSeasonBanner(result)
            setComplete(!!template && !!banner/* && !!preBanner && !!result*/)
        }
        reader.onerror = () => {
            setError('Invalid Image')
        }
        reader.readAsDataURL(file);
    }

    const saveActivitiesAssets = (activityTag) => async (event) => {
 
        var file = event.target.files[0];
        event.target.value=null;
        setError()

        var reader = new FileReader();
        reader.onload = async (e) => {
            let result = e.target.result
            setActivitiesAsset(activitiesAsset => ({
                ...activitiesAsset,
                [activityTag]:  result
            }))
        }
        reader.onerror = () => {
            setError('Invalid Image')
        }
        reader.readAsDataURL(file);
    }

    const uploadCompetition = async () => {
        setUploading(true)
        setError()
        await DatabaseService.createCompetition({
            data: template,
            format: templateFormat,
            public: isPublic,
            assetDataURL: banner,
            preAssetDataURL: preBanner ?? banner,
            seasonAssetDataURL: seasonBanner ?? banner,
            activitiesAssetMap: activitiesAsset
        }).then(() => {
            setUploading(false)
            onClose()
        }, (e) => {
            setUploading(false)
            setError(e.message)
        })
    }

    return (
        <Modal open style={style.content} size='large' onClose={onClose}>
            <Modal.Header>{'Upload Challenge Template'}</Modal.Header>
            <Modal.Content> 
                <Modal.Description>
                    <input ref={templateSelector} style={{display: 'none'}} type="file" accept='.json,.xlsx' onChange={saveTemplate}/>
                    <input ref={bannerSelector} style={{display: 'none'}} type="file" accept='.jpg,.jpeg,.png' onChange={saveBanner}/>
                    <input ref={preBannerSelector} style={{display: 'none'}} type="file" accept='.jpg,.jpeg,.png' onChange={savePreBanner}/>
                    <input ref={seasonBannerSelector} style={{display: 'none'}} type="file" accept='.jpg,.jpeg,.png' onChange={saveSeasonBanner}/>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={4}><b>{'Template JSON/XLSX'}</b></Grid.Column>
                            <Grid.Column width={12}><Button type="button" style={style.button} onClick={uploadJSON}>{'Upload'}</Button> {template && <Icon name="check circle"></Icon>} <span>{templateFile}</span></Grid.Column>
                        </Grid.Row> 
                        <Grid.Row>
                            <Grid.Column width={4}><b>{'Public'}</b></Grid.Column>
                            <Grid.Column width={12}><Checkbox toggle checked={isPublic} style={style.togglePacks} onChange={() => setIsPublic(!isPublic)} /></Grid.Column>
                        </Grid.Row> 
                        <Grid.Row>
                            <Grid.Column width={4}><b>{'Card Banner'}</b></Grid.Column>
                            <Grid.Column width={12}><Button type="button" disabled={!!error} style={style.button} onClick={uploadBanner}>{'Upload'}</Button> { banner && <Icon name="check circle"></Icon> } <span>{bannerFile}</span></Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={4}><b>{'Pre-enroll Banner (optional)'}</b></Grid.Column>
                            <Grid.Column width={12}><Button type="button" disabled={!!error} style={style.button} onClick={uploadPreBanner}>{'Upload'}</Button> { preBanner && <Icon name="check circle"></Icon> } <span>{preBannerFile}</span></Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={4}><b>{'Active Banner (optional)'}</b></Grid.Column>
                            <Grid.Column width={12}><Button type="button" disabled={!!error} style={style.button} onClick={uploadSeasonBanner}>{'Upload'}</Button> { seasonBanner && <Icon name="check circle"></Icon> } <span>{seasonBannerFile}</span></Grid.Column>
                        </Grid.Row>

                        {
                            Object.keys(activitiesAsset).map((activityTag, i) => (
                            
                                <Grid.Row key={i} >
                                    <Grid.Column width={4}><b>{`${i+1}. Activity Image (${activityTag}):`}</b></Grid.Column>
                                    <Grid.Column width={12}>
                                        <Button type="button" style={style.button} disabled={!!error} onClick={()=>activitiesFileRefs.current[i].click()}>{'Upload'}</Button>
                                        {activitiesAsset[activityTag] && <Icon name="check circle"></Icon>}
                                    </Grid.Column>
                                    <input 
                                        ref={el => activitiesFileRefs.current[i] = el} 
                                        style={{display: 'none'}} 
                                        type="file" accept='.jpg,.jpeg,.png' 
                                        onChange={saveActivitiesAssets(activityTag)}
                                    />
                                </Grid.Row> 
                                
                            ))
                        }
                    </Grid>
                    
                    <div>{ error }</div>
                    <p>Note: Combined size of all the assets should be less than 5 MB.</p>
                    <Button type="button" style={style.button} onClick={uploadCompetition} disabled={!complete || uploading}>{uploading ? 'Saving...' : t('Save')}</Button> 
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}

export default connect()(withTranslation('competitions')(UploadCompetitionTemplateModel));